/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME,RESPONSE_MULTIPLE_MESSAGE, ON_CALL_UPLOAD, LOADER_STATUS, RESPONSE_MESSAGE, PROFILE_DATA, UPDATE_MODULE,SET_RADIO_VAL, SET_MODULE,SET_OTP_BOX, OTP_INVALID} from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  loaderStatus: false,
  msg: '',
  status: false,
  profileData: [],
  error: 0,
  module: "eInv",
  radioVal: "EINV",
  modules:[],
  isOtpActive: false,
  isOtpInvalid:false,
  eInvResultMsg: '',
  ewbResultMsg:'',
  gstResultMsg:'',
  b2cResultMsg:'',
};

/* eslint-disable default-case, no-param-reassign */
const landingReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case RESPONSE_MESSAGE:
        return {
          ...state,
          msg:action.msg,
          status:action.status,
          error:action.error
        }
        case RESPONSE_MULTIPLE_MESSAGE:
          return {
            ...state,
            eInvResultMsg:action.eInvResultMsg,
            ewbResultMsg:action.ewbResultMsg,
            gstResultMsg:action.gstResultMsg,
            b2cResultMsg:action.b2cResultMsg,
            status:action.status,
            error:action.error
          }
      case PROFILE_DATA:
        return {
          ...state,
          profileData:action.profileData
        }
      case UPDATE_MODULE:
        return {
          ...state,
          module:action.module
        }
      case SET_RADIO_VAL:
        return {
          ...state,
          radioVal:action.radioVal
        }
      case SET_MODULE:
        return {
          ...state,
          modules:action.modules
        }
      case SET_OTP_BOX:
        return {
          ...state,
          isOtpActive:action.status
        }
      case OTP_INVALID:
        return {
          ...state,
          isOtpInvalid:action.status
        }
        default:
          return state;
    }
  };

export default landingReducer;
